var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRevenue = function SvgRevenue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "revenue_svg__a",
    x: 0,
    y: 0,
    width: 81.926,
    height: 32.834,
    rx: 2.414
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(40 -8.743 -91.798)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "revenue_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#revenue_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#revenue_svg__b)",
    stroke: "#9254DE",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.351 28.238 7.792-.371 16.095 3.475 16.45-13.195 17.508-.213 15.242-8.321 15.998-5.434h7.238"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(40 -11.634 -93.245)",
    fill: "#9254DE"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.783,
    cy: 29.047,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.936,
    cy: 25.569,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.492,
    cy: 15.84,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.006,
    cy: 15.626,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.253,
    cy: 7.297,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.996,
    cy: 1.814,
    r: 1
  })))));
};
export default SvgRevenue;